import React from 'react';
import './heroPanel.css';

const cx = (...parts) => parts.filter(Boolean).join(' ');

export const HeroPanelChip = ({ label, value, accent, className, children, ...rest }) => (
    <span
        className={cx('paneHeaderChip', accent && `paneHeaderChip--${accent}`, className)}
        {...rest}
    >
        {label != null && <span className="paneHeaderChipLabel">{label}</span>}
        {value != null && <span className="paneHeaderChipValue">{value}</span>}
        {children}
    </span>
);

export const HeroPanelTotal = ({ label, value, unit, sub, className }) => (
    <div className={cx('paneHeaderTotalBox', className)}>
        {label != null && <span className="paneHeaderTotalLabel">{label}</span>}
        {value != null && <span className="paneHeaderTotalValue">{value}</span>}
        {unit != null && <span className="paneHeaderTotalUnit">{unit}</span>}
        {sub != null && <span className="paneHeaderTotalSub">{sub}</span>}
    </div>
);

const HeroPanel = ({
    eyebrow,
    title,
    hint,
    tone,
    aside,
    footer,
    children,
    className,
    style,
    ...rest
}) => (
    <section
        className={cx('paneHeader', tone && `paneHeader--${tone}`, className)}
        data-tone={tone}
        style={style}
        {...rest}
    >
        <div className="paneHeaderTop">
            <div className="paneHeaderMain">
                {eyebrow != null && <span className="paneHeaderEyebrow">{eyebrow}</span>}
                {title != null && <span className="paneHeaderTitle">{title}</span>}
                {hint != null && <div className="paneHeaderHint">{hint}</div>}
                {children && <div className="paneHeaderChips">{children}</div>}
            </div>
            {aside && <div className="paneHeaderSide">{aside}</div>}
        </div>
        {footer && <div className="paneHeaderFooter">{footer}</div>}
    </section>
);

export default HeroPanel;
